import http from "./http";

export const fetchTransactionData = () => http.get("/transactions");
export const fetchWithdrawalRequests = () => http.get("/transactions/wallet/withdraw");
export const executeWithdrawFunds = (credentials) => http.post("/transactions/wallet/withdraw", credentials)
export const getUserTransaction = (id) => http.get(`/transactions/customer/${id}`)
export const executeUpdateRequestStatus = (id, payload) => http.patch(`/transactions/withdraw/${id}/update`, payload)